import { FaImage, FaMusic, FaVideo, FaEllipsisH } from "react-icons/fa"

export function getProductIcon(productType: string) {
  if (productType.startsWith("image/")) {
    return FaImage
  }

  if (productType.startsWith("audio/")) {
    return FaMusic
  }

  if (productType.startsWith("video/")) {
    return FaVideo
  }

  return FaEllipsisH
}
